export default "<navbar></navbar>";